import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { cloneElement, PureComponent } from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
var Coordination = /*#__PURE__*/function (_PureComponent) {
  _inherits(Coordination, _PureComponent);
  var _super = _createSuper(Coordination);
  function Coordination() {
    var _this;
    _classCallCheck(this, Coordination);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldRenderChildren: false
    });
    _defineProperty(_assertThisInitialized(_this), "stop", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, client, messageId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, client = _this$props.client, messageId = _this$props.messageId;
            _context.prev = 1;
            _context.next = 4;
            return client.stop(messageId);
          case 4:
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            // eslint-disable-next-line no-console
            console.error("Unable to stop flow message ".concat(messageId, ". ").concat(_context.t0));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    })));
    return _this;
  }
  _createClass(Coordination, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props2, client, messageId, started;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = this.props, client = _this$props2.client, messageId = _this$props2.messageId;
              _context2.prev = 1;
              _context2.next = 4;
              return client.start(messageId);
            case 4:
              started = _context2.sent;
              if (started) {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                  shouldRenderChildren: true
                });
              }
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              // eslint-disable-next-line no-console
              console.error("Unable to start flow message ".concat(messageId, ". ").concat(_context2.t0));
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 8]]);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "injectStop",
    value: function injectStop(children) {
      return /*#__PURE__*/cloneElement(children, {
        stop: this.stop
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fallback = _this$props3.fallback,
        children = _this$props3.children;
      var shouldRenderChildren = this.state.shouldRenderChildren;
      return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
  }]);
  return Coordination;
}(PureComponent);
_defineProperty(Coordination, "defaultProps", {
  fallback: null
});
export { Coordination as default };